const features = [
  {
    title: '全网最快更新',
    desc: '多渠道信息源实时同步，第一时间推送最新爆料，让你永远快人一步掌握热点动态。',
    icon: 'ri-flashlight-line',
  },
  {
    title: '独家深度内容',
    desc: '专业编辑团队深度挖掘，提供圈内独家视角与幕后故事，不止于表面八卦，更有深度解读。',
    icon: 'ri-sparkling-line',
  },
  {
    title: '严格信息把关',
    desc: '每一条51吃瓜最新爆料均经多源交叉验证，杜绝虚假信息传播，做有态度的吃瓜平台。',
    icon: 'ri-shield-check-line',
  },
  {
    title: '友好社区氛围',
    desc: '理性吃瓜、文明讨论，打造最温暖的吃瓜社区。在这里，每一位吃瓜群众都能畅所欲言。',
    icon: 'ri-chat-smile-2-line',
  },
];

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center gap-3 mb-8">
          <span className="w-1 h-7 rounded-full bg-primary-500"></span>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950" style={{ fontFamily: 'var(--font-heading)' }}>
            平台优势
          </h2>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {features.map((item, i) => (
            <div
              key={i}
              className="group bg-background-50 rounded-xl border border-background-200/60 p-6 hover:border-primary-200/60 transition-colors cursor-default"
            >
              <div className="w-12 h-12 rounded-xl bg-primary-100 flex items-center justify-center mb-4 group-hover:bg-primary-200 transition-colors">
                <i className={`${item.icon} text-primary-600 text-xl`}></i>
              </div>
              <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 mb-2" style={{ fontFamily: 'var(--font-heading)' }}>
                {item.title}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed">
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}